import { render, staticRenderFns } from "./SidebarCartDrawer.vue?vue&type=template&id=c3e8fb70&scoped=true&"
import script from "./SidebarCartDrawer.vue?vue&type=script&lang=js&"
export * from "./SidebarCartDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e8fb70",
  null
  
)

export default component.exports